import { combineReducers } from 'redux';

import { SupplierDetailReducerState, supplierDetailReducer } from '../supplier-detail/store/supplier-detail-reducer';

export interface SuppliersReducerState {
    supplierDetail: SupplierDetailReducerState;
}

export const suppliersReducer = combineReducers<SuppliersReducerState>({
    supplierDetail: supplierDetailReducer,
});
